import { useDispatch, useSelector } from "react-redux";
import {
  ConfirmModalProps,
  confirmModalActions,
} from "store/confirmModalSlice";
import { AppDispatch, RootState } from "store/store";
import confirmModalThunkActions from "store/thunk/confirmModalThunkActions";

export const useConfirmModal = () => {
  const dispatch: AppDispatch = useDispatch();
  const { isOpen, title, message, description, confirmText, cancelText } = useSelector(
    (state: RootState) => ({
      isOpen: state.confirmModal.isOpen,
      title: state.confirmModal.title,
      message: state.confirmModal.message,
      description: state.confirmModal.description,
      confirmText: state.confirmModal.confirmText,
      cancelText: state.confirmModal.cancelText,
    })
  );

  const open = async (confirmModalProps: ConfirmModalProps) => {
    const { payload } = await dispatch(
      confirmModalThunkActions.open(confirmModalProps)
    );
    return payload;
  };

  const confirm = () => {
    return dispatch(confirmModalActions.confirm());
  };

  const decline = () => {
    return dispatch(confirmModalActions.decline());
  };

  return {
    isOpen,
    title,
    message,
    description,
    confirmText,
    cancelText,
    open,
    confirm,
    decline,
  };
};

export default useConfirmModal;
